function prependTelProtocol(phoneNumber: string): string {
  return `tel:${phoneNumber}`;
}

/**
 * Formats a phone number as a clickable link by optionally adding the "tel:" prefix.
 * @param {String} phoneNumber The phone number string.
 * @param {boolean} addTelPrefix Flag to determine if "tel:" should be prepended. Defaults to true.
 * @return {String} The formatted phone number URL.
 */
export const formatPhoneLink = (phoneNumber: string, addTelPrefix = true) => {
  if (!phoneNumber) {
    return '';
  }
  const formattedString = phoneNumber.replaceAll(/\s/g, '');

  if (addTelPrefix) {
    return prependTelProtocol(formattedString);
  }

  return formattedString;
};
